if (!customElements.get('who-we-help')) {
  customElements.define(
    'who-we-help',
    class WhoWeHelp extends HTMLElement {
      constructor() {
        super();
        this.imageStackIntervals = [];
      }

      connectedCallback() {
        this.initImageStackAnimation();
      }

      disconnectedCallback() {
        // Clear all intervals on cleanup
        this.imageStackIntervals.forEach(interval => clearInterval(interval));
        this.imageStackIntervals = [];
      }

      initImageStackAnimation() {
        const audienceItems = this.querySelectorAll('.audience-item');
        
        audienceItems.forEach(item => {
          const imageStack = item.querySelector('.audience-item__images');
          if (!imageStack) return;

          const cards = Array.from(imageStack.querySelectorAll('.image-stack__card'));
          if (cards.length === 0) return;

          // Store image elements and their original sources
          const images = cards.map(card => card.querySelector('img'));
          const imageSources = images.map(img => img.src);

          // Ensure all images start with full opacity
          images.forEach(img => {
            img.style.opacity = '1';
          });

          // Store data for this stack
          const stackData = { images, imageSources };

          // Cycle through cards every 2 seconds
          const interval = setInterval(() => {
            this.rotateCardImages(stackData);
          }, 2000);

          this.imageStackIntervals.push(interval);
        });
      }

      rotateCardImages(stackData) {
        const { images, imageSources } = stackData;
        
        // Step 1: Start fading out current images
        images.forEach(img => {
          img.style.opacity = '0.7';
        });
        
        // Step 2: At halfway point, swap image sources for cross-fade effect
        setTimeout(() => {
          // Rotate image sources: move first to last (1,2,3 → 2,3,1 → 3,1,2)
          imageSources.push(imageSources.shift());
          
          // Apply new sources and immediately start fading in
          images.forEach((img, index) => {
            img.src = imageSources[index];
            // Use setTimeout to ensure src change registers before opacity change
            setTimeout(() => {
              img.style.opacity = '1';
            }, 10);
          });
          
        }, 200); // Swap at midpoint of 400ms fade for smooth cross-fade
      }
    }
  );
}
